export const manifestLocales = {
  interactivePoll: {
    previewImageAlt: {
      en: 'Interactive poll',
      he: 'Interactive poll [HE]'
    },
    initialHeadlineText: {
      en: 'Headline / Question',
      he: 'כותרת/שאלה'
    },
    defaultAnswer: {
      en: 'Answer',
      he: 'תשובה'
    }
  }
};
